import { Injectable } from '@angular/core';
import { ColumnDefinition, ColumnDefinitions, ColumnGroup } from './column-group.class';
import { noPositiveYesNegativeCssClass } from '../helpers/data.helpers';
import { TranslationsService } from '../services/translations.service';
import { booleanDataMap } from '../data/data-maps/generic.data';

@Injectable({ providedIn: 'root' })
export class AlertsColumns extends ColumnGroup {
  public constructor(private translations: TranslationsService) {
    super();
  }

  protected columnDefinitions: ColumnDefinitions = {
    unresolvedVrmAlert: () => ({
      width: 120,
      refData: this.translations.translateDataMap(booleanDataMap),
      cellClass: (params) => noPositiveYesNegativeCssClass(params.value),
    }),
  };
}
